// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.102.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@charset \"UTF-8\"\n/**\n * @description 全局主题变量配置\n */", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu-color": "hsla(0, 0%, 100%, 0.95)",
	"menu-color-active": "hsla(0, 0%, 100%, 0.95)",
	"menu-background": "#282c34",
	"column-second-menu-background": "#fff",
	"vab-border-radius": "2.5px",
	"vab-color-grey": "rgba(0, 0, 0, 0.65)",
	"vab-color-black": "#515a6e",
	"vab-color-primary": "#1890ff",
	"vab-color-primary-light-1": "color-mix(#ffffff, #1890ff, 10%)",
	"vab-color-primary-light-2": "color-mix(#ffffff, #1890ff, 20%)",
	"vab-color-primary-light-3": "color-mix(#ffffff, #1890ff, 30%)",
	"vab-color-primary-light-4": "color-mix(#ffffff, #1890ff, 40%)",
	"vab-color-primary-light-5": "color-mix(#ffffff, #1890ff, 50%)",
	"vab-color-primary-light-6": "color-mix(#ffffff, #1890ff, 60%)",
	"vab-color-primary-light-7": "color-mix(#ffffff, #1890ff, 70%)",
	"vab-color-primary-light-8": "color-mix(#ffffff, #1890ff, 80%)",
	"vab-color-primary-light-9": "color-mix(#ffffff, #1890ff, 90%)",
	"vab-color-success": "#13ce66",
	"vab-color-success-light": "color-mix(#ffffff, #13ce66, 80%)",
	"vab-color-success-lighter": "color-mix(#ffffff, #13ce66, 90%)",
	"vab-color-warning": "#ffba00",
	"vab-color-warning-light": "color-mix(#ffffff, #ffba00, 80%)",
	"vab-color-warning-lighter": "color-mix(#ffffff, #ffba00, 90%)",
	"vab-color-danger": "#ff4d4f",
	"vab-color-danger-light": "color-mix(#ffffff, #ff4d4f, 80%)",
	"vab-color-danger-lighter": "color-mix(#ffffff, #ff4d4f, 90%)",
	"vab-color-error": "#ff4d4f",
	"vab-color-error-light": "color-mix(#ffffff, #ff4d4f, 80%)",
	"vab-color-error-lighter": "color-mix(#ffffff, #ff4d4f, 90%)",
	"vab-color-info": "#999",
	"vab-color-info-light": "color-mix(#ffffff, #999, 80%)",
	"vab-color-info-lighter": "color-mix(#ffffff, #999, 90%)",
	"vab-border-radius-base": "2.5px",
	"vab-color-transition": "#77e19d",
	"vab-left-menu-width": "266px"
};
export default ___CSS_LOADER_EXPORT___;
